// Address
export const addressLabel = 'Address'
export const address2Label = 'Address (line 2)'
export const cityLabel = 'City'
export const stateLabel = 'State'
export const zipCodeLabel = 'Zip code'
export const countryLabel = 'Country'
export const homeAddressLabel = 'Home address'

// Email
export const emailLabel = 'Email address'
export const personalEmailLabel = 'Personal email'
export const workEmailLabel = 'Work email'

// Name
export const nameLabel = 'Name'
export const firstNameLabel = 'First name'
export const middleNameLabel = 'Middle name'
export const lastNameLabel = 'Last name'
export const suffixLabel = 'Suffix'
export const individualCategoryLabel = 'Category'

// Personal Information
export const ageLabel = 'Age'
export const aliasLabel = 'Alias/Nickname'
export const dobLabel = 'Date of birth'
export const medicareNumberLabel = 'Medicare number'
export const medicaidNumberLabel = 'Medicaid number'
export const physicalDescLabel = 'Physical description'
export const ssnLabel = 'Social Security Number (SSN)'
export const sexLabel = 'Sex'

// Phone
export const cellPhoneLabel = 'Cell phone'
export const employerPhoneLabel = 'Employer phone'
export const homePhoneLabel = 'Home phone'
export const officePhoneLabel = 'Office phone'
export const phoneLabel = 'Phone number'
export const workCellPhoneLabel = 'Work cell phone'
export const workPhoneLabel = 'Work phone'

// Business
export const additionalIdLabel = 'Additional identifying information'
export const alternatePhoneLabel = 'Alternate phone'
export const businessNameLabel = 'Business/Department name'
export const businessPhoneLabel = 'Business phone'
export const businessCategoryLabel = 'Category'
export const dbaLabel = 'Doing Business As (DBA)'
export const einLabel = 'Employer ID Number (EIN)'
export const npiLabel = 'National Provider ID (NPI)'
export const websiteLabel = 'Website'

// Not categorized labels
export const complaintTypeLabel = 'Complaint type'
export const contractNumberLabel = 'Contract number'
export const employerLabel = 'Employer'
export const executiveDirectorLabel =
  'Principal investigator/ Executive director'
export const grantNumberLabel = 'Grant number'
export const hhsEmployeeTypeLabel = 'HHS employment type'
export const jobTitleLabel = 'Job title'
export const optionalLabel = 'Optional'
export const otherRelationshipLabel = 'Please enter relationship'
export const retaliationLabel = 'Experienced retaliation'
